import Vue from 'vue';
import VueRouter from 'vue-router';
import vuelidateWrap from 'services/libWrappers/vuelidate/vuelidate';
import generalConfig from 'services/metaData/generalConfig';
import GoogleTagManager from '@/plugins/googleTagManager';
import store from '@/store';
import 'components/modals/ModalAPI';
import 'components/notification/NotificationAPI';
import tooltip from 'services/libWrappers/vue-tooltip';
import App from './App.vue';
import router from './router';

const config = generalConfig();

Vue.use(GoogleTagManager, {
    id: 'GTM-N27NNNG',
    enabled: Boolean(config.isProduction)
});
vuelidateWrap(Vue);
Vue.use(VueRouter);
tooltip(Vue);

new Vue({
    router,
    render: (h) => h(App),
    store
}).$mount('#app');
